import { useQuery } from "./helper";
import { getLineItemCategoryList } from "../../../api/line-item-category";
import { TLineItemCategory } from "../../types/line-item-category";
import { TResponseItemWrapper } from "../../types/common";

export const useLineItemCategoryList = (options) => useQuery<TResponseItemWrapper<TLineItemCategory[]>>({
    queryKey: ['line-item-categories'],
    queryFn: () => getLineItemCategoryList(),
    ...options
});
